/**
 * flyToCart — clones the product image and animates it flying into the
 * header cart icon (element marked with data-cart-fly-target), then
 * gives the icon a quick pop. No-ops silently when either end is
 * missing or the user prefers reduced motion.
 */
export function flyToCart(sourceImg) {
  if (!sourceImg || typeof sourceImg.getBoundingClientRect !== "function") return;

  let target = null;
  for (const t of document.querySelectorAll("[data-cart-fly-target]")) {
    const r = t.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) {
      target = { el: t, rect: r };
      break;
    }
  }
  if (!target) return;

  const from = sourceImg.getBoundingClientRect();
  if (from.width === 0) return;

  const size = Math.min(from.width, 90);
  const clone = sourceImg.cloneNode(false);
  Object.assign(clone.style, {
    position: "fixed",
    left: `${from.left + from.width / 2 - size / 2}px`,
    top: `${from.top + from.height / 2 - size / 2}px`,
    width: `${size}px`,
    height: `${size}px`,
    objectFit: "cover",
    borderRadius: "9999px",
    zIndex: 9999,
    pointerEvents: "none",
    margin: 0,
  });
  document.body.appendChild(clone);

  const dx =
    target.rect.left + target.rect.width / 2 - (from.left + from.width / 2);
  const dy =
    target.rect.top + target.rect.height / 2 - (from.top + from.height / 2);

  const popIcon = () => {
    clone.remove();
    if (typeof target.el.animate === "function") {
      target.el.animate(
        [
          { transform: "scale(1)" },
          { transform: "scale(1.25)" },
          { transform: "scale(1)" },
        ],
        { duration: 280, easing: "ease-out" }
      );
    }
  };

  if (typeof clone.animate !== "function") {
    // Older WebKit without WAAPI — CSS transition fallback.
    clone.style.transition =
      "transform 650ms cubic-bezier(0.45, 0, 0.55, 1), opacity 650ms ease";
    requestAnimationFrame(() => {
      clone.style.transform = `translate(${dx}px, ${dy}px) scale(0.12)`;
      clone.style.opacity = "0.35";
    });
    setTimeout(popIcon, 680);
    return;
  }

  const anim = clone.animate(
    [
      { transform: "translate(0, 0) scale(1)", opacity: 1 },
      {
        transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 40}px) scale(0.55)`,
        opacity: 0.9,
      },
      { transform: `translate(${dx}px, ${dy}px) scale(0.12)`, opacity: 0.35 },
    ],
    { duration: 650, easing: "cubic-bezier(0.45, 0, 0.55, 1)" }
  );
  anim.onfinish = popIcon;
}
